import React from 'react';
import { EmptyState, IconLock, Workspace } from '../../ui/v2';
import { useEventsSession } from './EventsScopeContext';
import type { EventsCapability, EventsSession } from './api/types';

export function can(
  session: EventsSession | null | undefined,
  capability: EventsCapability,
): boolean {
  return !!session?.capabilities.includes(capability);
}

export function useEventsCan(capability: EventsCapability): boolean {
  return can(useEventsSession(), capability);
}

/** Renders children only when the session grants the capability. */
export function IfCapable({
  capability,
  children,
}: {
  capability: EventsCapability;
  children: React.ReactNode;
}) {
  return useEventsCan(capability) ? <>{children}</> : null;
}

/** Page-level gate: a quiet explanation instead of a 403 page. */
export function RequireCapability({
  capability,
  title,
  children,
}: {
  capability: EventsCapability;
  title: string;
  children: React.ReactNode;
}) {
  if (useEventsCan(capability)) return <>{children}</>;
  return (
    <Workspace title="Events">
      <div className="v2-scroll min-h-0 flex-1 overflow-y-auto">
        <EmptyState
          icon={<IconLock />}
          title={`Your role doesn't include ${title.toLowerCase()}`}
          description="Ask an owner or director to change your events role if you need this."
        />
      </div>
    </Workspace>
  );
}
